import { createFileRoute } from "@tanstack/react-router";

import { ServicePageLayout } from "../components/site/ServicePageLayout";
import { ContactForm } from "../components/home/ContactForm";
import { ClientsMarquee } from "../components/shared/ClientsMarquee";
import { Showreel } from "../components/home/Showreel";
import { Reviews } from "../components/shared/Reviews";
import { Team } from "../components/shared/Team";
import { Stats } from "../components/shared/Stats";
import { LandingHero } from "../components/landing/LandingHero";
import { LandingRibbons } from "../components/landing/LandingRibbons";
import { LandingRequests } from "../components/landing/LandingRequests";
import { LandingCases } from "../components/landing/LandingCases";
import { LandingCallForm } from "../components/landing/LandingCallForm";
import { LandingProcess } from "../components/landing/LandingProcess";
import { LandingPricing } from "../components/landing/LandingPricing";
import { buildMeta, serviceJsonLd, SITE_URL } from "../lib/site";
import { Toaster } from "../components/ui/sonner";

const title = "Разработка сайтов на Tilda под ключ — стоимость | HAY.agency";
const description =
  "Разрабатываем сайты и лендинги на Tilda под ключ: аналитика, прототип, дизайн, тексты, адаптив, интеграции и запуск. Рассчитаем стоимость проекта.";

export const Route = createFileRoute("/landing")({
  head: () => ({
    ...buildMeta({ title, description, path: "/landing", image: `${SITE_URL}/og/services/landing.webp`, imageWidth: 1200, imageHeight: 630, imageAlt: "Разработка лендингов и сайтов на Тильде — HAY.agency", locale: "ru_RU" }),
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          serviceJsonLd({
            name: "Разработка сайтов на Tilda",
            description,
            path: "/landing",
          }),
        ),
      },
    ],
  }),
  component: LandingPage,
});

function LandingPage() {
  return (
    <ServicePageLayout breadcrumb="Сайты на Tilda">
      <LandingHero />
      <LandingRibbons />
      <LandingRequests />
      <div className="pb-10 pt-14 lg:pb-[74px] lg:pt-[110px]">
        <ClientsMarquee bare />
      </div>
      <Showreel />
      <LandingCases />
      <LandingCallForm
        id="call"
        title="Созвонимся и обсудим ваши задачи"
        description="Предложим структуру сайта, возможности конверсии, привлечение трафика и варианты аналитики"
        submitLabel="Отправить"
      />
      <LandingProcess />
      <LandingPricing />
      <LandingCallForm
        title="Прототип сайта в подарок"
        description="Сложно решиться? Чтобы точно представить, как будет работать ваш сайт, мы создадим предварительную структуру, которая даст понимание будущего продукта."
        submitLabel="Получить прототип"
        tone="grey"
      />
      <Reviews />
      <Team />
      <Stats />
      <ContactForm />
      <Toaster />
    </ServicePageLayout>
  );
}
